import { z } from 'zod';

export const jumperSessionStatusSchema = z.enum([
  'pending',
  'active',
  'completed',
  'expired',
  'aborted',
]);

export const jumperSessionSchema = z.object({
  id: z.string(),
  deviceId: z.string(),
  detectionGroupId: z.string().nullable(),
  detectionGroupCreatedAt: z.string().nullable(),
  startFrequencyHz: z.number(),
  endFrequencyHz: z.number(),
  durationSeconds: z.number(),
  status: jumperSessionStatusSchema,
  startedAt: z.string().nullable(),
  expiresAt: z.string().nullable(),
  finishedAt: z.string().nullable(),
  reason: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type JumperSessionStatus = z.infer<typeof jumperSessionStatusSchema>;
export type JumperSession = z.infer<typeof jumperSessionSchema>;

export const TERMINAL_JUMPER_SESSION_STATUSES: readonly JumperSessionStatus[] = [
  'completed',
  'expired',
  'aborted',
] as const;

export const isTerminalJumperSessionStatus = (status: JumperSessionStatus): boolean =>
  TERMINAL_JUMPER_SESSION_STATUSES.includes(status);
